import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const OAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      // Check for session_id in URL fragment
      const hash = window.location.hash;
      console.log('OAuth Callback - Full hash:', hash);
      
      if (!hash) {
        console.log('No hash in URL, skipping OAuth callback');
        return;
      }

      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');
      console.log('Extracted session_id:', sessionId);

      if (sessionId) {
        console.log('Processing Google OAuth callback with session_id:', sessionId);
        
        try {
          // Exchange session_id for user data using fetch (better for CORS)
          console.log('Calling Emergent session-data endpoint...');
          const emergentResponse = await fetch(
            'https://demobackend.emergentagent.com/auth/v1/env/oauth/session-data',
            {
              method: 'GET',
              headers: {
                'X-Session-ID': sessionId
              }
            }
          );

          if (!emergentResponse.ok) {
            throw new Error(`Emergent API error: ${emergentResponse.status}`);
          }

          const userData = await emergentResponse.json();
          console.log('Received user data from Emergent:', userData);
          
          const { email, name, session_token } = userData;

          // Save session to backend and get JWT token
          console.log('Calling backend google-login endpoint...');
          const authResponse = await axios.post(`${API_URL}/api/auth/google-login`, {
            email,
            name,
            session_token
          });

          console.log('Received JWT token from backend');

          // Save JWT token
          localStorage.setItem('token', authResponse.data.token);

          // Clean URL
          window.history.replaceState(null, '', window.location.pathname);

          // Show success and reload
          toast.success('Successfully signed in with Google!');
          setTimeout(() => {
            window.location.href = '/';
          }, 1000);

        } catch (error) {
          console.error('OAuth callback error:', error);
          console.error('Error details:', error.response?.data);
          toast.error('Failed to complete Google sign in: ' + (error.response?.data?.detail || error.message));
          setTimeout(() => {
            navigate('/login');
          }, 2000);
        }
      } else {
        console.log('No session_id found in URL hash');
      }
    };

    handleOAuthCallback();
  }, [navigate]);

  return null;
};

export default OAuthCallback;
